import { useEffect, useRef } from 'react';
import VConsole from 'vconsole';

const useVConsole = () => {
  const vConsoleRef = useRef<VConsole | null>(null);

  useEffect(() => {
    if (!vConsoleRef.current) {
      vConsoleRef.current = new VConsole();
    }
    return () => {
      // Cleanup on unmount
      if (vConsoleRef.current) {
        vConsoleRef.current.destroy();
        vConsoleRef.current = null;
      }
    };
  }, []);

  return vConsoleRef;
};

export default useVConsole;
